export const pushMessage = (text: string, variant: 'success' | 'error' | 'info' | 'warning') => ({
  type: 'PUSH_MESSAGE',
  text,
  variant
});

export const shiftMessage = () => (dispatch: any) =>
  dispatch({
    type: 'SHIFT_MESSAGE'
  });
